import { createApp } from 'vue'
import Mil from './Mil.vue'
import './assets/global.css'

createApp(Mil).mount('#mil')
